export class IcMIncident {
    public icmNumber: number;
    public comments: string;

    constructor(icmNumber: number, comments: string) {
      this.icmNumber = icmNumber;
      this.comments = comments;
  }
}
